type Props = {
  icon: React.ReactNode;
  title: React.ReactNode;
  meta?: React.ReactNode;
  details?: React.ReactNode;
  notes?: React.ReactNode;
  statusDetails?: React.ReactNode;
  right?: React.ReactNode;
  selected?: boolean;
  dimmed?: boolean;
  colors: {
    bar: string;
    soft: string;
    ink: string;
  };
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export default function DetailedListItem({
  icon,
  title,
  meta,
  details,
  notes,
  statusDetails,
  right,
  selected = false,
  dimmed = false,
  colors,
  onClick,
}: Props) {
  return (
    <div
      className={`group flex items-start transition-colors hover:bg-accent/30 ${
        selected ? "ring-1 ring-inset ring-foreground/20" : ""
      } ${dimmed ? "opacity-60" : ""}`}
      style={{ background: colors.soft, color: colors.ink }}
    >
      <button
        type="button"
        onClick={onClick}
        className="flex min-w-0 flex-1 items-start gap-2 px-3 py-2.5 text-left"
      >
        <span className="mt-0.5 h-4 w-4 shrink-0" style={{ color: colors.bar }}>
          {icon}
        </span>
        <span className="min-w-0 flex-1 space-y-1">
          <span className="block truncate text-sm font-semibold">{title}</span>
          {meta && (
            <span className="block truncate text-[11px] font-mono tabular-nums opacity-70">
              {meta}
            </span>
          )}
          {details && (
            <span className="block truncate text-xs opacity-70">
              {details}
            </span>
          )}
          {notes && (
            <span className="block truncate text-xs opacity-60">
              {notes}
            </span>
          )}
        </span>
      </button>
      {(right || statusDetails) && (
        <div className="flex shrink-0 flex-col items-end gap-1 px-2 py-2.5">
          {right}
          {statusDetails && (
            <div className="flex max-w-36 flex-col items-end gap-0.5 text-right">
              <span className="text-[11px] font-mono tabular-nums opacity-70">
                {statusDetails}
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
